import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_14() {
  return (
    <NoteContainer date={'14/10/2025'} version="20.12.0">
      <VStack w="full">
        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento']}>
          <GeneralContainer>
            <VStack w="full">
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle>Cancelamento automático de requisições duplicadas</TaskTitle>
                  <TaskBreadcrumb>Geral</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, quando o front solicita a mesma chamada para a API mais de uma vez, somente a última é
                    considerada válida e todas as outras canceladas
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </GeneralContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do erro de filtragem</TaskTitle>
                <TaskBreadcrumb>Regulação/ Painel de Solicitações</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que ocasionava na quebra da página ao pesquisar certos registros
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
